import { dateFormatData, search_word } from '../../../Functions';

export function CargoArrivalNotice(XLSX, data, user) {
    // console.log('excel data', data)
    var wb = XLSX.utils.book_new();
    data.forEach((element, id) => {
        //CHARGES FOR INQUIRY PLS REFER TO THE LIST OF CHARGES 
        const freight = element.charges.find(_freight => _freight.part === 'FREIGHT');
        const arrastre_origin = element.charges.find(_arrastre_origin => _arrastre_origin.part === 'PORT_ORIGIN' && (_arrastre_origin.chargeCode === '004' || _arrastre_origin.chargeCode === '007' || _arrastre_origin.chargeCode === '008'));
        const arrastre_destination = element.charges.find(_arrastre_destination => _arrastre_destination.part === 'PORT_DESTINATION' && (_arrastre_destination.chargeCode === '004' || _arrastre_destination.chargeCode === '007' || _arrastre_destination.chargeCode === '008'));
        const weighing_fee = element.charges.find(_weighing_fee => _weighing_fee.part === 'PORT_ORIGIN' && _weighing_fee.chargeCode === '005');
        const trucking_origin = element.charges.find(_trucking_origin => _trucking_origin.part === 'TRUCKING_ORIGIN' && ((search_word(_trucking_origin.particulars, 'Trucking Tariff') === 'Trucking Tariff') || (_trucking_origin.chargeCode === '006')));
        const trucking_destination = element.charges.find(_trucking_destination => _trucking_destination.part === 'TRUCKING_DESTINATION' && ((search_word(_trucking_origin.particulars, 'Trucking Tariff') === 'Trucking Tariff') || (_trucking_origin.chargeCode === '006')));
        const cy_stuffing_area = element.charges.find(_cy_stuffing_area => _cy_stuffing_area.part === 'PORT_ORIGIN' && _cy_stuffing_area.chargeCode === '009');
        const cy_stripping_area = element.charges.find(_cy_stripping_area => _cy_stripping_area.part === 'PORT_DESTINATION' && _cy_stripping_area.chargeCode === '010');
        const cy_stripping_mano = element.charges.find(_cy_stripping_mano => _cy_stripping_mano.part === 'PORT_DESTINATION' && _cy_stripping_mano.chargeCode === '011');
        const stripping_mano = element.charges.find(_stripping_mano => _stripping_mano.part === 'TRUCKING_DESTINATION' && _stripping_mano.chargeCode === '012');
        const stuffing_mano = element.charges.find(_stuffing_mano => _stuffing_mano.part === 'TRUCKING_ORIGIN' && _stuffing_mano.chargeCode === '013');
        // const lift_on_origin = element.charges.find(_lift_on_origin => _lift_on_origin.part === 'PORT_ORIGIN' && _lift_on_origin.chargeCode === '014');
        // const lift_on_destination = element.charges.find(_lift_on_destination => _lift_on_destination.part === 'PORT_DESTINATION' && _lift_on_origin.chargeCode === '014');

        const insurance = element.terms.find(term => term.policyCode === 'C0004');
        //END FOR CHARGES

        var ws = XLSX.utils.json_to_sheet([
            { A: 'OCEAN TRANSPORT GROUP OF COMPANIES INC.' }
        ], { header: [], skipHeader: true });

        XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: "CARGO ARRIVAL NOTICE" }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 });

        XLSX.utils.sheet_add_json(ws, [{ A: `Consignee: ${element.consigneeName}` }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: `Vessel: ${element.vessel}` }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: `Voyage Reference: ${element.voyageRef}` }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: `Date of Arrival: ${dateFormatData(new Date(element.arrivalDate))}` }], { header: [], skipHeader: true, origin: -1 });

        XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: "We are pleased to inform the arrival of your cargoes confirmed loaded on board above-stated vessel" }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 });

        if (element.modeOfPayment === 'Prepaid') {
            XLSX.utils.sheet_add_json(ws, [{
                A: "VAN NO.",
                B: "SEAL NO.",
                C: "WAYBILL NO.",
                D: "SHIPPER",
                E: "SERVICE MODE",
                F: "PAY MODE",
                G: "AMOUNT PAYABLES"
            }], { header: [], skipHeader: true, origin: -1 });

            XLSX.utils.sheet_add_json(ws, [{
                A: element.cargo,
                B: element.sealNum,
                C: element.wayBillRef,
                D: element.shipper,
                E: element.modeOfDelivery,
                F: element.modeOfPayment,
                G: element.amountPaybles
            }], { header: [], skipHeader: true, origin: -1 });
            var wscols = [
                { wch: 15 }, // Van No
                { wch: 10 }, // Seal No
                { wch: 14 }, // Waybill
                { wch: 25 }, // Shipper
                { wch: 13 }, // Service Mode
                { wch: 15 }, // Pay Mode
                { wch: 17 }, // Amount Payable
            ];
            ws['!cols'] = wscols;
        } else {
            if (element.modeOfDelivery === 'PTP') {
                const totalPTP =
                    (freight && freight.chargeValue ? freight.chargeValue : 0) +
                    (arrastre_origin && arrastre_origin.chargeValue ? arrastre_origin.chargeValue : 0) +
                    (arrastre_destination && arrastre_destination.chargeValue ? arrastre_destination.chargeValue : 0) +
                    (cy_stuffing_area && cy_stuffing_area.chargeValue ? cy_stuffing_area.chargeValue : 0) +
                    (cy_stripping_area && cy_stripping_area.chargeValue ? cy_stripping_area.chargeValue : 0) +
                    (cy_stripping_mano && cy_stripping_mano.chargeValue ? cy_stripping_mano.chargeValue : 0) +
                    (weighing_fee && weighing_fee.chargeValue ? weighing_fee.chargeValue : 0) +
                    (insurance && insurance.value ? insurance.value : 0);

                XLSX.utils.sheet_add_json(ws, [{
                    A: "VAN NO.",
                    B: "SEAL NO.",
                    C: "WAYBILL NO.",
                    D: "SHIPPER",
                    E: "SERVICE MODE",
                    F: "PAY MODE",
                    G: "FREIGHT",
                    H: `ARRASTRE ${element.origin}`,
                    I: `ARRASTRE ${element.destination}`,
                    J: "CY STUFFING (AREA)",
                    K: "CY STRIPPING (AREA)",
                    L: "CY STRIPPING (MANO)",
                    M: "WEIGHING FEE",
                    N: "INSURANCE",
                    O: "TOTAL"
                }], { header: [], skipHeader: true, origin: -1 });

                XLSX.utils.sheet_add_json(ws, [{
                    A: element.cargo,
                    B: element.sealNum,
                    C: element.wayBillRef,
                    D: element.shipper,
                    E: element.modeOfDelivery,
                    F: element.modeOfPayment,
                    G: freight && freight.chargeValue ? freight.chargeValue : 0,
                    H: arrastre_origin && arrastre_origin.chargeValue ? arrastre_origin.chargeValue : 0,
                    I: arrastre_destination && arrastre_destination.chargeValue ? arrastre_destination.chargeValue : 0,
                    J: cy_stuffing_area && cy_stuffing_area.chargeValue ? cy_stuffing_area.chargeValue : 0,
                    K: cy_stripping_area && cy_stripping_area.chargeValue ? cy_stripping_area.chargeValue : 0,
                    L: cy_stripping_mano && cy_stripping_mano.chargeValue ? cy_stripping_mano.chargeValue : 0,
                    M: weighing_fee && weighing_fee.chargeValue ? weighing_fee.chargeValue : 0,
                    N: insurance && insurance.value ? insurance.value : 0,
                    O: totalPTP
                }], { header: [], skipHeader: true, origin: -1 });

                var wscolsPTP = [
                    { wch: 15 }, // A
                    { wch: 10 }, // B
                    { wch: 14 }, // C
                    { wch: 25 }, // D
                    { wch: 13 }, // E
                    { wch: 15 }, // F
                    { wch: 10 }, // G
                    { wch: 15 }, // H
                    { wch: 15 }, // I
                    { wch: 20 }, // J
                    { wch: 20 }, // K
                    { wch: 20 }, // L
                    { wch: 15 }, // M 
                    { wch: 10 }, // N 
                    { wch: 10 }, // O
                ];
                ws['!cols'] = wscolsPTP;

            } else if (element.modeOfDelivery === 'PTD') {
                const totalPTD =
                    (freight && freight.chargeValue ? freight.chargeValue : 0) +
                    (arrastre_origin && arrastre_origin.chargeValue ? arrastre_origin.chargeValue : 0) +
                    (arrastre_destination && arrastre_destination.chargeValue ? arrastre_destination.chargeValue : 0) +
                    (weighing_fee && weighing_fee.chargeValue ? weighing_fee.chargeValue : 0) +
                    (cy_stuffing_area && cy_stuffing_area.chargeValue ? cy_stuffing_area.chargeValue : 0) +
                    (cy_stripping_area && cy_stripping_area.chargeValue ? cy_stripping_area.chargeValue : 0) +
                    (cy_stripping_mano && cy_stripping_mano.chargeValue ? cy_stripping_mano.chargeValue : 0) +
                    (trucking_destination && trucking_destination.chargeValue ? trucking_destination.chargeValue : 0) +
                    (stripping_mano && stripping_mano.chargeValue ? stripping_mano.chargeValue : 0) +
                    (insurance && insurance.value ? insurance.value : 0);

                XLSX.utils.sheet_add_json(ws, [{
                    A: "VAN NO.",
                    B: "SEAL NO.",
                    C: "WAYBILL NO.",
                    D: "SHIPPER",
                    E: "SERVICE MODE",
                    F: "PAY MODE",
                    G: "FREIGHT",
                    H: `ARRASTRE ${element.origin}`,
                    I: `ARRASTRE ${element.destination}`,
                    J: "WEIGHING FEE",
                    K: "CY STUFFING (AREA)",
                    L: "CY STRIPPING (AREA)",
                    M: "CY STRIPPING (MANO)",
                    N: `TRUCKING ${element.destination}`,
                    O: 'STRIPPING (MANO)',
                    P: "INSURANCE",
                    Q: "TOTAL"
                }], { header: [], skipHeader: true, origin: -1 });

                XLSX.utils.sheet_add_json(ws, [{
                    A: element.cargo,
                    B: element.sealNum,
                    C: element.wayBillRef,
                    D: element.shipper,
                    E: element.modeOfDelivery,
                    F: element.modeOfPayment,
                    G: freight && freight.chargeValue ? freight.chargeValue : 0,
                    H: arrastre_origin && arrastre_origin.chargeValue ? arrastre_origin.chargeValue : 0,
                    I: arrastre_destination && arrastre_destination.chargeValue ? arrastre_destination.chargeValue : 0,
                    J: weighing_fee && weighing_fee.chargeValue ? weighing_fee.chargeValue : 0,
                    K: cy_stuffing_area && cy_stuffing_area.chargeValue ? cy_stuffing_area.chargeValue : 0,
                    L: cy_stripping_area && cy_stripping_area.chargeValue ? cy_stripping_area.chargeValue : 0,
                    M: cy_stripping_mano && cy_stripping_mano.chargeValue ? cy_stripping_mano.chargeValue : 0,
                    N: trucking_destination && trucking_destination.chargeValue ? trucking_destination.chargeValue : 0,
                    O: stripping_mano && stripping_mano.chargeValue ? stripping_mano.chargeValue : 0,
                    P: insurance && insurance.value ? insurance.value : 0,
                    Q: totalPTD
                }], { header: [], skipHeader: true, origin: -1 });

                var wscolsPTD = [
                    { wch: 15 }, // A
                    { wch: 10 }, // B
                    { wch: 14 }, // C
                    { wch: 25 }, // D
                    { wch: 13 }, // E
                    { wch: 15 }, // F
                    { wch: 10 }, // G
                    { wch: 15 }, // H
                    { wch: 15 }, // I
                    { wch: 15 }, // J
                    { wch: 20 }, // K
                    { wch: 20 }, // L
                    { wch: 20 }, // M 
                    { wch: 15 }, // N 
                    { wch: 15 }, // O
                    { wch: 10 }, // P
                    { wch: 10 }, // Q
                ];
                ws['!cols'] = wscolsPTD;

            } else if (element.modeOfDelivery === 'DTP') {
                const totalDTP =
                    (freight && freight.chargeValue ? freight.chargeValue : 0) +
                    (arrastre_origin && arrastre_origin.chargeValue ? arrastre_origin.chargeValue : 0) +
                    (arrastre_destination && arrastre_destination.chargeValue ? arrastre_destination.chargeValue : 0) +
                    (weighing_fee && weighing_fee.chargeValue ? weighing_fee.chargeValue : 0) +
                    (cy_stuffing_area && cy_stuffing_area.chargeValue ? cy_stuffing_area.chargeValue : 0) +
                    (cy_stripping_area && cy_stripping_area.chargeValue ? cy_stripping_area.chargeValue : 0) +
                    (cy_stripping_mano && cy_stripping_mano.chargeValue ? cy_stripping_mano.chargeValue : 0) +
                    (trucking_origin && trucking_origin.chargeValue ? trucking_origin.chargeValue : 0) +
                    (stuffing_mano && stuffing_mano.chargeValue ? stuffing_mano.chargeValue : 0) +
                    (insurance && insurance.value ? insurance.value : 0);

                XLSX.utils.sheet_add_json(ws, [{
                    A: "VAN NO.",
                    B: "SEAL NO.",
                    C: "WAYBILL NO.",
                    D: "SHIPPER",
                    E: "SERVICE MODE",
                    F: "PAY MODE",
                    G: "FREIGHT",
                    H: `ARRASTRE ${element.origin}`,
                    I: `ARRASTRE ${element.destination}`,
                    J: "WEIGHING FEE",
                    K: "CY STUFFING (AREA)",
                    L: "CY STRIPPING (AREA)",
                    M: "CY STRIPPING (MANO)",
                    N: `TRUCKING ${element.origin}`,
                    O: "STUFFING (MANO)",
                    P: "INSURANCE",
                    Q: "TOTAL"
                }], { header: [], skipHeader: true, origin: -1 });

                XLSX.utils.sheet_add_json(ws, [{
                    A: element.cargo,
                    B: element.sealNum,
                    C: element.wayBillRef,
                    D: element.shipper,
                    E: element.modeOfDelivery,
                    F: element.modeOfPayment,
                    G: freight && freight.chargeValue ? freight.chargeValue : 0,
                    H: arrastre_origin && arrastre_origin.chargeValue ? arrastre_origin.chargeValue : 0,
                    I: arrastre_destination && arrastre_destination.chargeValue ? arrastre_destination.chargeValue : 0,
                    J: weighing_fee && weighing_fee.chargeValue ? weighing_fee.chargeValue : 0,
                    K: cy_stuffing_area && cy_stuffing_area.chargeValue ? cy_stuffing_area.chargeValue : 0,
                    L: cy_stripping_area && cy_stripping_area.chargeValue ? cy_stripping_area.chargeValue : 0,
                    M: cy_stripping_mano && cy_stripping_mano.chargeValue ? cy_stripping_mano.chargeValue : 0,
                    N: trucking_origin && trucking_origin.chargeValue ? trucking_origin.chargeValue : 0,
                    O: stuffing_mano && stuffing_mano.chargeValue ? stuffing_mano.chargeValue : 0,
                    P: insurance && insurance.value ? insurance.value : 0,
                    Q: totalDTP
                }], { header: [], skipHeader: true, origin: -1 });

                var wscolsDTP = [
                    { wch: 15 }, // A
                    { wch: 10 }, // B
                    { wch: 14 }, // C
                    { wch: 25 }, // D
                    { wch: 13 }, // E
                    { wch: 15 }, // F
                    { wch: 10 }, // G
                    { wch: 15 }, // H
                    { wch: 15 }, // I
                    { wch: 15 }, // J
                    { wch: 20 }, // K
                    { wch: 20 }, // L
                    { wch: 20 }, // M 
                    { wch: 15 }, // N 
                    { wch: 15 }, // O
                    { wch: 10 }, // P
                    { wch: 10 }, // Q
                ];
                ws['!cols'] = wscolsDTP;

            } else if (element.modeOfDelivery === 'DTD') {
                const totalDTD =
                    (freight && freight.chargeValue ? freight.chargeValue : 0) +
                    (arrastre_origin && arrastre_origin.chargeValue ? arrastre_origin.chargeValue : 0) +
                    (arrastre_destination && arrastre_destination.chargeValue ? arrastre_destination.chargeValue : 0) +
                    (weighing_fee && weighing_fee.chargeValue ? weighing_fee.chargeValue : 0) +
                    (cy_stuffing_area && cy_stuffing_area.chargeValue ? cy_stuffing_area.chargeValue : 0) +
                    (cy_stripping_area && cy_stripping_area.chargeValue ? cy_stripping_area.chargeValue : 0) +
                    (cy_stripping_mano && cy_stripping_mano.chargeValue ? cy_stripping_mano.chargeValue : 0) +
                    (trucking_origin && trucking_origin.chargeValue ? trucking_origin.chargeValue : 0) +
                    (trucking_destination && trucking_destination.chargeValue ? trucking_destination.chargeValue : 0) +
                    (stripping_mano && stripping_mano.chargeValue ? stripping_mano.chargeValue : 0) +
                    (stuffing_mano && stuffing_mano.chargeValue ? stuffing_mano.chargeValue : 0) +
                    (insurance && insurance.value ? insurance.value : 0);

                XLSX.utils.sheet_add_json(ws, [{
                    A: "VAN NO.",
                    B: "SEAL NO.",
                    C: "WAYBILL NO.",
                    D: "SHIPPER",
                    E: "SERVICE MODE",
                    F: "PAY MODE",
                    G: "FREIGHT",
                    H: `ARRASTRE ${element.origin}`,
                    I: `ARRASTRE ${element.destination}`,
                    J: "WEIGHING FEE",
                    K: "CY STUFFING (AREA)",
                    L: "CY STRIPPING (AREA)",
                    M: "CY STRIPPING (MANO)",
                    N: `TRUCKING ${element.origin}`,
                    O: `TRUCKING ${element.destination}`,
                    P: "STRIPPING (MANO)",
                    Q: "STUFFING (MANO)",
                    R: "INSURANCE",
                    S: "TOTAL"
                }], { header: [], skipHeader: true, origin: -1 });

                XLSX.utils.sheet_add_json(ws, [{
                    A: element.cargo,
                    B: element.sealNum,
                    C: element.wayBillRef,
                    D: element.shipper,
                    E: element.modeOfDelivery,
                    F: element.modeOfPayment,
                    G: freight && freight.chargeValue ? freight.chargeValue : 0,
                    H: arrastre_origin && arrastre_origin.chargeValue ? arrastre_origin.chargeValue : 0,
                    I: arrastre_destination && arrastre_destination.chargeValue ? arrastre_destination.chargeValue : 0,
                    J: weighing_fee && weighing_fee.chargeValue ? weighing_fee.chargeValue : 0,
                    K: cy_stuffing_area && cy_stuffing_area.chargeValue ? cy_stuffing_area.chargeValue : 0,
                    L: cy_stripping_area && cy_stripping_area.chargeValue ? cy_stripping_area.chargeValue : 0,
                    M: cy_stripping_mano && cy_stripping_mano.chargeValue ? cy_stripping_mano.chargeValue : 0,
                    N: trucking_origin && trucking_origin.chargeValue ? trucking_origin.chargeValue : 0,
                    O: trucking_destination && trucking_destination.chargeValue ? trucking_destination.chargeValue : 0,
                    P: stripping_mano && stripping_mano.chargeValue ? stripping_mano.chargeValue : 0,
                    Q: stuffing_mano && stuffing_mano.chargeValue ? stuffing_mano.chargeValue : 0,
                    R: insurance && insurance.value ? insurance.value : 0,
                    S: totalDTD
                }], { header: [], skipHeader: true, origin: -1 });
            
                var wscolsDTD = [
                    { wch: 15 }, // A
                    { wch: 10 }, // B
                    { wch: 14 }, // C
                    { wch: 25 }, // D
                    { wch: 13 }, // E
                    { wch: 15 }, // F
                    { wch: 10 }, // G
                    { wch: 15 }, // H
                    { wch: 15 }, // I
                    { wch: 15 }, // J
                    { wch: 20 }, // K
                    { wch: 20 }, // L
                    { wch: 20 }, // M 
                    { wch: 15 }, // N 
                    { wch: 15 }, // O
                    { wch: 15 }, // P
                    { wch: 15 }, // Q
                    { wch: 10 }, // R
                    { wch: 10 }, // S
                ];
                ws['!cols'] = wscolsDTD;
            }
        }
        if(element.terms && element.terms.length > 0){
            //TERMS
            XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 });
            XLSX.utils.sheet_add_json(ws, [{ A: "IMPORTANT" }], { header: [], skipHeader: true, origin: -1 });
            element.terms.forEach((element, i) => {
                XLSX.utils.sheet_add_json(ws, [{ A: `${i + 1}. ${element.policyName}` }], { header: [], skipHeader: true, origin: -1 });
            });
        }
        XLSX.utils.sheet_add_json(ws, [{ A: "" }], { header: [], skipHeader: true, origin: -1 });
        XLSX.utils.sheet_add_json(ws, [{ A: `PREPARED BY: ${user.name}` }], { header: [], skipHeader: true, origin: -1 });
        //END OF TERMS

        XLSX.utils.book_append_sheet(wb, ws, id + ") " +element.wayBillRef);

    })
    XLSX.writeFile(wb, "Cargo_Arrival_Notice.xlsx");
};